import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Music4 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function RequestDialog({ open, onOpenChange, station, initialSong = "", initialArtist = "" }) {
  const [song, setSong] = useState("");
  const [artist, setArtist] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  React.useEffect(() => {
    if (open) { setSong(initialSong || ""); setArtist(initialArtist || ""); }
  }, [open, initialSong, initialArtist]);

  const submit = async (e) => {
    e.preventDefault();
    if (!song.trim()) return;
    setLoading(true);
    try {
      await api.post("/requests", { song, artist, message, station_id: station?.id || null });
      toast.success("Request sent! The DJ will see it soon.");
      setSong(""); setArtist(""); setMessage("");
      onOpenChange(false);
    } catch (e) {
      toast.error("Could not send request");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#141C42] border-white/10 text-white" data-testid="request-dialog">
        <DialogHeader>
          <DialogTitle className="font-display font-extrabold text-2xl tracking-tight flex items-center gap-2">
            <Music4 className="w-5 h-5 text-[#E6B34A]" /> Request a Song
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4 mt-2">
          <div>
            <label className="overline text-zinc-400">Song title</label>
            <Input value={song} onChange={(e) => setSong(e.target.value)} placeholder="Amazing Grace" data-testid="request-song" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A]" />
          </div>
          <div>
            <label className="overline text-zinc-400">Artist (optional)</label>
            <Input value={artist} onChange={(e) => setArtist(e.target.value)} placeholder="Chris Tomlin" data-testid="request-artist" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A]" />
          </div>
          <div>
            <label className="overline text-zinc-400">Message (optional)</label>
            <Textarea value={message} onChange={(e) => setMessage(e.target.value)} placeholder="A dedication or shout-out..." data-testid="request-message" className="mt-1.5 bg-[#1E2A5A] border-white/10 focus-visible:ring-[#E6B34A]" />
          </div>
          <button type="submit" disabled={loading} data-testid="request-submit" className="w-full py-3 rounded-xl bg-[#E6B34A] text-[#0A1030] font-bold hover:bg-[#CF9A34] transition-colors disabled:opacity-60">
            {loading ? "Sending..." : "Send Request"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
